import { MaybeRefOrGetter } from "vue";
import { Arrayable, MaybeComputedElementRef } from "@vueuse/core";
import { useFocusTrap as useFocusTrapLib, UseFocusTrapOptions } from "@vueuse/integrations/useFocusTrap";
/**
 * Wraps the VueUse `useFocusTrap` to ensure functionality with NG's focus trap.
 *
 * Also allows for focus trap stacking by using a global stack.
 */
export const useFocusTrap = (
    target: Arrayable<MaybeRefOrGetter<string> | MaybeComputedElementRef>,
    options?: UseFocusTrapOptions
) => {
    // Ensure the global focus trap stack is initialized
    if (!(window as any).__focusTrapStack) {
        (window as any).__focusTrapStack = [];
    }
    const focusTrap = useFocusTrapLib(target, {
        allowOutsideClick: true,
        trapStack: (window as any).__focusTrapStack, // Use global focus trap stack to enable focus trap stacking
        ...options,
    });
    function addNgHsListener() {
        ng_hs.onStateChange((state) => {
            if (!focusTrap.hasFocus) return;
            if (state === "active") {
                focusTrap.pause();
            } else {
                focusTrap.unpause();
            }
        });
    }

    // NG is not used on Sazka Klub
    if (typeof ngLoader !== "undefined") {
        if (ngLoader.ngIsReady()) {
            addNgHsListener();
        } else {
            document.addEventListener("fwReady", addNgHsListener);
        }
    }

    return focusTrap;
};
